import { client } from "../request";

/**
 * 現場のプロパティキー
 */
export interface ProjectFolderDefault {
  id: string;
  name: string;
  type: string | null;
}

/**
 * 現場のプロパティキーの一覧を取得する
 */
export async function getAllProjectFolderDefaults(
  type: string
): Promise<ProjectFolderDefault[]> {
  return await client.get("get_all_service_folder_default.php", { type });
}

export interface SaveProjectFolderDefaultCommand {
  id?: string;
  name: string;
  type: string;
}

/**
 * 現場のプロパティキーを保存する
 */
export async function saveProjectFolderDefault(
  command: SaveProjectFolderDefaultCommand
) {
  const data = new FormData();
  if (command.id) {
    data.append("id", command.id);
  }
  data.append("name", command.name);
  data.append("type", command.type);
  await client.post("create_service_folder_default.php", data);
}

/**
 * 現場のプロパティキーを削除する
 */
export async function deleteProjectFolderDefault(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await client.post("delete_service_folder_default.php", data);
}

/**
 * 現場のプロパティキーを取得する
 */
export async function getProjectFolderDefault(
  id: string
): Promise<ProjectFolderDefault | null> {
  return await client.get("get_service_folder_default.php", { id });
}
